export const translations = {
  en: {
    omzet: "Revenue",
    alarmen: "Alerts",
    transacties: "Transactions",
    instellingen: "Settings",
    sites: "Sites",
    producten: "Products",
    terminals: "Terminals",
    locaties: "Locations",
    alarmdefinities: "Alerts",
    automaten: "Machines",
    logout: "Logout",
    gebruikers: "Users",
    alarmdetails: "Alert Details",
    alarmdefinitiedetails: "Alert Definition Details",
    lokatiedetails: "Location Details",
    productdetails: "Product Details",
    sitedetails: "Site Details",
    terminaldetails: "Terminal Details",
    transactiedetails: "Transaction Details",
    automaatdetails: "Machine Details",
    terminalcontract: "Contracts",
    productKoppeldetails: "Product link details",
    productenKoppelen: "Products linking",
    locatieKoppelen: "Location linking",
    automaatKoppelen: "Machine linking",
    typeKoppelen: "Type linking",
    automaat: 'Machine',
    details: ' details',
    toevoegen: 'add',
  },
  nl: {
    omzet: "Omzet",
    alarmen: "Alarmen",
    transacties: "Transacties",
    instellingen: "Instellingen",
    sites: "Sites",
    producten: "Producten",
    terminals: "Terminals",
    locaties: "Locaties",
    alarmdefinities: "Alarmen",
    automaten: "Automaten",
    logout: "Uitloggen",
    gebruikers: "Gebruikers",
    alarmdetails: "Alarmdetails",
    alarmdefinitiedetails: "Alarminstellingdetails",
    lokatiedetails: "Locatiedetails",
    productdetails: "Productdetails",
    sitedetails: "Sitedetails",
    terminaldetails: "Terminaldetails",
    transactiedetails: "Transactiondetails",
    automaatdetails: "Machinedetails",
    terminalcontract: "contracten",
    productKoppeldetails: "Product koppeldetails",
    productenKoppelen: "Producten koppelen",
    locatieKoppelen: "Locatie koppelen",
    automaatKoppelen: "Automaat koppelen",
    typeKoppelen: "Type koppelen",
    automaat: 'Automaat',
    details: 'details',
    toevoegen: 'toevoegen',
  },
  de: {
    omzet: "Umsatz",
    alarmen: "Alarme",
    transacties: "Transaktionen",
    instellingen: "Einstellungen",
    sites: "Standorte",
    producten: "Produkte",
    terminals: "Terminals",
    locaties: "Standorte",
    alarmdefinities: "Alarme",
    automaten: "Automaten",
    logout: "Abmelden",
    gebruikers: "Benutzer",
    alarmdetails: "Alarmdetails",
    alarmdefinitiedetails: "Alarminstellingdetails",
    lokatiedetails: "Standortdetails",
    productdetails: "Produktdetails",
    sitedetails: "Standortdetails",
    terminaldetails: "Terminaldetails",
    transactiedetails: "Transaktionsdetails",
    automaatdetails: "Automatendetails",
    terminalcontract: "vertragen",
    productKoppeldetails: "Produktverbindungsdetails",
    productenKoppelen: "Produkte koppeln",
    locatieKoppelen: "Standort koppeln",
    automaatKoppelen: "Automat koppeln",
    typeKoppelen: "Typ koppeln",
    automaat: 'Automat',
    details: 'details',
    toevoegen: 'hinzufügen',
  },
} as const;

export type TranslationKey = keyof typeof translations.en;
